const STORAGE_KEY = "shapeAccordionState";

export type AccordionState = {
    basic: boolean;
    diagrams: boolean;
    bpmn: boolean;
    uml: boolean;
};

export const loadAccordionState = (): AccordionState | null => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw) as Partial<Record<keyof AccordionState, unknown>>;

        return {
            basic: typeof parsed.basic === "boolean" ? parsed.basic : true,
            diagrams: typeof parsed.diagrams === "boolean" ? parsed.diagrams : false,
            bpmn: typeof parsed.bpmn === "boolean" ? parsed.bpmn : false,
            uml: typeof parsed.uml === "boolean" ? parsed.uml : false,
        };
    } catch {
        return null;
    }
};

export const saveAccordionState = (state: AccordionState): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {}
};
